import { IOrderTemplate, OrderTemplate } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'
import { sortBy } from 'lodash'
import stockApi from 'src/api/stockApi'

export enum QueryKeys {
  getOrderTemplates = 'order-templates',
}

export const getAll = async (
  includeDeletedTemplates: boolean = false
): Promise<IOrderTemplate[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getOrderTemplates, includeDeletedTemplates],
    queryFn: async ({ signal }) => {
      const orderTemplates = await stockApi.getOrderTemplates(
        includeDeletedTemplates,
        signal
      )

      return sortBy<IOrderTemplate>(orderTemplates, 'templateName')
    },
  })
}

export const get = async (id: string): Promise<IOrderTemplate | null> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['orderTemplate', id],
    queryFn: async () => {
      return await stockApi.getOrderTemplate(id)
    },
  })
}

export const remove = async (id: string): Promise<void> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return

  return await stockApi.deleteOrderTemplate(id)
}

export const update = async (
  orderTemplateId: string,
  body?: OrderTemplate
): Promise<IOrderTemplate | null> => {
  return await stockApi.updateOrderTemplate(orderTemplateId, body)
}
